/**
 * The carousel's step list: Welcome → Role → Tools → one clip per KEPT tool
 * that has a video → Done. Recomputed as tools are toggled, which only adds
 * or removes clip steps after the current one — the current step id stays.
 */
export function buildSteps(tools, hidden) {
  const hiddenSet = new Set(hidden || []);
  const clips = tools
    .filter((tool) => tool.video && !hiddenSet.has(tool.id))
    .map((tool) => ({ id: `feature:${tool.id}`, kind: 'feature', tool }));
  return [
    { id: 'welcome', kind: 'welcome' },
    { id: 'role', kind: 'role' },
    { id: 'tools', kind: 'tools' },
    ...clips,
    { id: 'done', kind: 'done' },
  ];
}
